module.exports = __webpack_public_path__ + "img/a2.6d062d7c.jpg";